import { create } from 'zustand'
import {
  getFarms, getFarmGlobal, getFarmInfoByUser, getFarmRewardByUser, getFarmLocks,
  formatFarmApr, formatLendApr, formatFarmUserInfo, formatFarmReward,
  type FarmPool, type FarmGlobal, type FarmLock,
} from '@/lib/farm-data'

interface MiningState {
  liquidityFarms: FarmPool[]
  liquidityGlobal: FarmGlobal
  lendFarms: FarmPool[]
  lendGlobal: FarmGlobal
  locks: FarmLock[]
  lendLocks: FarmLock[]
  fetchLiquidityFarms: (accountName?: string) => Promise<void>
  fetchLendFarms: (accountName?: string, lendList?: any[]) => Promise<void>
  fetchLocks: (accountName: string, contract?: string) => Promise<void>
}

export const useMiningStore = create<MiningState>()((set) => ({
  liquidityFarms: [],
  liquidityGlobal: { total_weight: 0 },
  lendFarms: [],
  lendGlobal: { total_weight: 0 },
  locks: [],
  lendLocks: [],

  fetchLiquidityFarms: async (accountName?: string) => {
    const [farms, global] = await Promise.all([
      getFarms('pools.ttr'),
      getFarmGlobal('pools.ttr'),
    ])
    let formatted = formatFarmApr(global, farms)

    if (accountName) {
      const [infoList, rewardList] = await Promise.all([
        getFarmInfoByUser(accountName, 'pools.ttr'),
        getFarmRewardByUser(accountName, 'pools.ttr'),
      ])
      formatted = formatFarmUserInfo(infoList, formatted, 'farm')
      formatted = formatFarmReward(rewardList, formatted)
    }

    set({ liquidityFarms: formatted, liquidityGlobal: global })
  },

  fetchLendFarms: async (accountName?: string, lendList: any[] = []) => {
    const [farms, global] = await Promise.all([
      getFarms('lendmine.ttr', lendList),
      getFarmGlobal('lendmine.ttr'),
    ])
    let formatted = formatLendApr(global, farms)

    if (accountName) {
      const [infoList, rewardList] = await Promise.all([
        getFarmInfoByUser(accountName, 'lendmine.ttr'),
        getFarmRewardByUser(accountName, 'lendmine.ttr'),
      ])
      formatted = formatFarmUserInfo(infoList, formatted, 'lend')
      formatted = formatFarmReward(rewardList, formatted)
    }

    set({ lendFarms: formatted, lendGlobal: global })
  },

  fetchLocks: async (accountName: string, contract = 'pools.ttr') => {
    const locks = await getFarmLocks(accountName, contract)
    if (contract === 'pools.ttr') {
      set({ locks })
    } else {
      set({ lendLocks: locks })
    }
  },
}))
